module.exports = __webpack_public_path__ + "media/images/text-fd5ccab3dfc5320cd716eae9cf205798.png";